import { render, staticRenderFns } from "./userRiskBuff.vue?vue&type=template&id=0bd09421&scoped=true"
import script from "./userRiskBuff.vue?vue&type=script&lang=ts"
export * from "./userRiskBuff.vue?vue&type=script&lang=ts"
import style0 from "./userRiskBuff.vue?vue&type=style&index=0&id=0bd09421&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd09421",
  null
  
)

export default component.exports